module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maurice Hinson, Wesley Roberts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Maurice Hinson is Senior Professor of Piano at the Southern Baptist Theological Seminary and was founding editor of the Journal of the American Liszt Society. ")]), _c('P', [_vm._v("Wesley Roberts is Professor of Music at Campbellsville University.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15XPTva/tc-custom/9780253010230.jpg?1721451107778",
      "alt": "This image is the cover for the book Guide to the Pianist's Repertoire, Indiana Repertoire Guides"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Guide to the Pianist's Repertoire, Indiana Repertoire Guides\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Guide to the Pianist's Repertoire continues to be the go-to source for piano performers, teachers, and students. Newly updated and expanded with more than 250 new composers, this incomparable resource expertly guides readers to solo piano literature and provides answers to common questions: What did a given composer write? What interesting work have I never heard of? How difficult is it? What are its special musical features? How can I reach the publisher? ")]), _c('p', [_vm._v("New to the fourth edition are enhanced indexes identifying black composers, women composers, and compositions for piano with live or recorded electronics; a thorough listing of anthologies and collections organized by time period and nationality, now including collections from Africa and Slovakia; and expanded entries to account for new material, works, and resources that have become available since the third edition, including websites and electronic resources. The \"newest Hinson\" will be an indispensible guide for many years to come.")]), _c('p'), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0